/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.b2b.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.b2b = {};
proto.witbooking.backoffice.b2b.v1 = require('./b2b_admin_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.b2b.v1.B2BAdminServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.b2b.v1.B2BAdminServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest,
 *   !proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse>}
 */
const methodDescriptor_B2BAdminService_ListEntities = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.b2b.v1.B2BAdminService/ListEntities',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest,
  proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse,
  /**
   * @param {!proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest,
 *   !proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse>}
 */
const methodInfo_B2BAdminService_ListEntities = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse,
  /**
   * @param {!proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.b2b.v1.B2BAdminServiceClient.prototype.listEntities =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.b2b.v1.B2BAdminService/ListEntities',
      request,
      metadata || {},
      methodDescriptor_B2BAdminService_ListEntities,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.b2b.v1.B2BAdminServicePromiseClient.prototype.listEntities =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.b2b.v1.B2BAdminService/ListEntities',
      request,
      metadata || {},
      methodDescriptor_B2BAdminService_ListEntities);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest,
 *   !proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse>}
 */
const methodDescriptor_B2BAdminService_ListCommercialTerms = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.b2b.v1.B2BAdminService/ListCommercialTerms',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest,
  proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse,
  /**
   * @param {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest,
 *   !proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse>}
 */
const methodInfo_B2BAdminService_ListCommercialTerms = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse,
  /**
   * @param {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.b2b.v1.B2BAdminServiceClient.prototype.listCommercialTerms =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.b2b.v1.B2BAdminService/ListCommercialTerms',
      request,
      metadata || {},
      methodDescriptor_B2BAdminService_ListCommercialTerms,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.b2b.v1.B2BAdminServicePromiseClient.prototype.listCommercialTerms =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.b2b.v1.B2BAdminService/ListCommercialTerms',
      request,
      metadata || {},
      methodDescriptor_B2BAdminService_ListCommercialTerms);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest,
 *   !proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse>}
 */
const methodDescriptor_B2BAdminService_UpdateCommercialTermsRow = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.b2b.v1.B2BAdminService/UpdateCommercialTermsRow',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest,
  proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse,
  /**
   * @param {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest,
 *   !proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse>}
 */
const methodInfo_B2BAdminService_UpdateCommercialTermsRow = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse,
  /**
   * @param {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.b2b.v1.B2BAdminServiceClient.prototype.updateCommercialTermsRow =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.b2b.v1.B2BAdminService/UpdateCommercialTermsRow',
      request,
      metadata || {},
      methodDescriptor_B2BAdminService_UpdateCommercialTermsRow,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.b2b.v1.B2BAdminServicePromiseClient.prototype.updateCommercialTermsRow =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.b2b.v1.B2BAdminService/UpdateCommercialTermsRow',
      request,
      metadata || {},
      methodDescriptor_B2BAdminService_UpdateCommercialTermsRow);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest,
 *   !proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse>}
 */
const methodDescriptor_B2BAdminService_DeleteCommercialTermsRow = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.b2b.v1.B2BAdminService/DeleteCommercialTermsRow',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest,
  proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse,
  /**
   * @param {!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest,
 *   !proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse>}
 */
const methodInfo_B2BAdminService_DeleteCommercialTermsRow = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse,
  /**
   * @param {!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.b2b.v1.B2BAdminServiceClient.prototype.deleteCommercialTermsRow =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.b2b.v1.B2BAdminService/DeleteCommercialTermsRow',
      request,
      metadata || {},
      methodDescriptor_B2BAdminService_DeleteCommercialTermsRow,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.b2b.v1.B2BAdminServicePromiseClient.prototype.deleteCommercialTermsRow =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.b2b.v1.B2BAdminService/DeleteCommercialTermsRow',
      request,
      metadata || {},
      methodDescriptor_B2BAdminService_DeleteCommercialTermsRow);
};


module.exports = proto.witbooking.backoffice.b2b.v1;

